import { stashConnectTicket } from './connect-ticket'

stashConnectTicket()
